/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { AVGApiConfig } from '../avg-api-config';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { AVGExportData } from '../models/avg-export-data';
import { AVGExportDetails } from '../models/avg-export-details';
import { AVGExportMederker } from '../models/avg-export-mederker';
import { AVGFeedback } from '../models/avg-feedback';
import { AVGSemConsent } from '../models/avg-sem-consent';
import { AVGSemPartyMarketplaceEntry } from '../models/avg-sem-party-marketplace-entry';
import { AVGSemPartyViewPageEntry } from '../models/avg-sem-party-view-page-entry';

@Injectable({
  providedIn: 'root',
})
export class AVGApiService extends BaseService {
  constructor(
    config: AVGApiConfig,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getMarketplaceEntries
   */
  static readonly GetMarketplaceEntriesPath = '/connect/avgdashboard/sem/marketplace';

  /**
   * Haal SEM koppelpartijen op. Zelfde rechten als koppelvlak, maar alleen beschikbaar als de SEM feature aan staat.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getMarketplaceEntries()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMarketplaceEntries$Response(params?: {
  }): Observable<StrictHttpResponse<Array<AVGSemPartyMarketplaceEntry>>> {

    const rb = new RequestBuilder(this.rootUrl, AVGApiService.GetMarketplaceEntriesPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<AVGSemPartyMarketplaceEntry>>;
      })
    );
  }

  /**
   * Haal SEM koppelpartijen op. Zelfde rechten als koppelvlak, maar alleen beschikbaar als de SEM feature aan staat.
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getMarketplaceEntries$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMarketplaceEntries(params?: {
  }): Observable<Array<AVGSemPartyMarketplaceEntry>> {

    return this.getMarketplaceEntries$Response(params).pipe(
      map((r: StrictHttpResponse<Array<AVGSemPartyMarketplaceEntry>>) => r.body as Array<AVGSemPartyMarketplaceEntry>)
    );
  }

  /**
   * Path part for operation getPartyDetails
   */
  static readonly GetPartyDetailsPath = '/connect/avgdashboard/sem/party/{uuid}';

  /**
   * Haal details van een SEM koppelpartij op. Zelfde rechten als koppelvlak, maar alleen beschikbaar als de SEM feature aan staat.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPartyDetails()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPartyDetails$Response(params: {
    uuid: string;
  }): Observable<StrictHttpResponse<AVGSemPartyViewPageEntry>> {

    const rb = new RequestBuilder(this.rootUrl, AVGApiService.GetPartyDetailsPath, 'get');
    if (params) {
      rb.path('uuid', params.uuid, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AVGSemPartyViewPageEntry>;
      })
    );
  }

  /**
   * Haal details van een SEM koppelpartij op. Zelfde rechten als koppelvlak, maar alleen beschikbaar als de SEM feature aan staat.
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getPartyDetails$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPartyDetails(params: {
    uuid: string;
  }): Observable<AVGSemPartyViewPageEntry> {

    return this.getPartyDetails$Response(params).pipe(
      map((r: StrictHttpResponse<AVGSemPartyViewPageEntry>) => r.body as AVGSemPartyViewPageEntry)
    );
  }

  /**
   * Path part for operation setSemConsent
   */
  static readonly SetSemConsentPath = '/connect/avgdashboard/sem/party/{uuid}/consent/{schoolId}';

  /**
   * Geef consent voor de gegeven SEM koppelpartij. Zelfde rechten als koppelvlak, maar alleen beschikbaar als de SEM feature aan staat.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `setSemConsent()` instead.
   *
   * This method doesn't expect any request body.
   */
  setSemConsent$Response(params: {
    uuid: string;
    schoolId: string;
  }): Observable<StrictHttpResponse<Array<AVGSemConsent>>> {

    const rb = new RequestBuilder(this.rootUrl, AVGApiService.SetSemConsentPath, 'post');
    if (params) {
      rb.path('uuid', params.uuid, {});
      rb.path('schoolId', params.schoolId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<AVGSemConsent>>;
      })
    );
  }

  /**
   * Geef consent voor de gegeven SEM koppelpartij. Zelfde rechten als koppelvlak, maar alleen beschikbaar als de SEM feature aan staat.
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `setSemConsent$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  setSemConsent(params: {
    uuid: string;
    schoolId: string;
  }): Observable<Array<AVGSemConsent>> {

    return this.setSemConsent$Response(params).pipe(
      map((r: StrictHttpResponse<Array<AVGSemConsent>>) => r.body as Array<AVGSemConsent>)
    );
  }

  /**
   * Path part for operation unsetSemConsent
   */
  static readonly UnsetSemConsentPath = '/connect/avgdashboard/sem/party/{uuid}/consent/{schoolId}';

  /**
   * Geef geen consent voor de gegeven SEM koppelpartij. Zelfde rechten als koppelvlak, maar alleen beschikbaar als de SEM feature aan staat.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `unsetSemConsent()` instead.
   *
   * This method doesn't expect any request body.
   */
  unsetSemConsent$Response(params: {
    uuid: string;
    schoolId: string;
  }): Observable<StrictHttpResponse<Array<AVGSemConsent>>> {

    const rb = new RequestBuilder(this.rootUrl, AVGApiService.UnsetSemConsentPath, 'delete');
    if (params) {
      rb.path('uuid', params.uuid, {});
      rb.path('schoolId', params.schoolId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<AVGSemConsent>>;
      })
    );
  }

  /**
   * Geef geen consent voor de gegeven SEM koppelpartij. Zelfde rechten als koppelvlak, maar alleen beschikbaar als de SEM feature aan staat.
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `unsetSemConsent$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  unsetSemConsent(params: {
    uuid: string;
    schoolId: string;
  }): Observable<Array<AVGSemConsent>> {

    return this.unsetSemConsent$Response(params).pipe(
      map((r: StrictHttpResponse<Array<AVGSemConsent>>) => r.body as Array<AVGSemConsent>)
    );
  }

  /**
   * Path part for operation setFeedback
   */
  static readonly SetFeedbackPath = '/connect/feedback';

  /**
   * Versturen van feedback op de Connect applicatie.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `setFeedback$Json()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  setFeedback$Json$Response(params: {
    body: AVGFeedback
  }): Observable<StrictHttpResponse<Array<AVGFeedback>>> {

    const rb = new RequestBuilder(this.rootUrl, AVGApiService.SetFeedbackPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<AVGFeedback>>;
      })
    );
  }

  /**
   * Versturen van feedback op de Connect applicatie.
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `setFeedback$Json$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  setFeedback$Json(params: {
    body: AVGFeedback
  }): Observable<Array<AVGFeedback>> {

    return this.setFeedback$Json$Response(params).pipe(
      map((r: StrictHttpResponse<Array<AVGFeedback>>) => r.body as Array<AVGFeedback>)
    );
  }

  /**
   * Versturen van feedback op de Connect applicatie.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `setFeedback$Xml()` instead.
   *
   * This method sends `application/xml` and handles request body of type `application/xml`.
   */
  setFeedback$Xml$Response(params: {
    body: AVGFeedback
  }): Observable<StrictHttpResponse<Array<AVGFeedback>>> {

    const rb = new RequestBuilder(this.rootUrl, AVGApiService.SetFeedbackPath, 'post');
    if (params) {
      rb.body(params.body, 'application/xml');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<AVGFeedback>>;
      })
    );
  }

  /**
   * Versturen van feedback op de Connect applicatie.
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `setFeedback$Xml$Response()` instead.
   *
   * This method sends `application/xml` and handles request body of type `application/xml`.
   */
  setFeedback$Xml(params: {
    body: AVGFeedback
  }): Observable<Array<AVGFeedback>> {

    return this.setFeedback$Xml$Response(params).pipe(
      map((r: StrictHttpResponse<Array<AVGFeedback>>) => r.body as Array<AVGFeedback>)
    );
  }

  /**
   * Path part for operation getExports
   */
  static readonly GetExportsPath = '/connect/avgdashboard/export';

  /**
   * Haal een lijst van exports op voor het gegeven datumbereik (zie queryparameters)
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getExports()` instead.
   *
   * This method doesn't expect any request body.
   */
  getExports$Response(params: {
    begindatum: string;
    einddatum: string;
    offset?: number;
    amount?: number;
    medewerkerUUID?: string;
  }): Observable<StrictHttpResponse<AVGExportData>> {

    const rb = new RequestBuilder(this.rootUrl, AVGApiService.GetExportsPath, 'get');
    if (params) {
      rb.query('begindatum', params.begindatum, {});
      rb.query('einddatum', params.einddatum, {});
      rb.query('offset', params.offset, {});
      rb.query('amount', params.amount, {});
      rb.query('medewerkerUUID', params.medewerkerUUID, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AVGExportData>;
      })
    );
  }

  /**
   * Haal een lijst van exports op voor het gegeven datumbereik (zie queryparameters)
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getExports$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getExports(params: {
    begindatum: string;
    einddatum: string;
    offset?: number;
    amount?: number;
    medewerkerUUID?: string;
  }): Observable<AVGExportData> {

    return this.getExports$Response(params).pipe(
      map((r: StrictHttpResponse<AVGExportData>) => r.body as AVGExportData)
    );
  }

  /**
   * Path part for operation getExportDetails
   */
  static readonly GetExportDetailsPath = '/connect/avgdashboard/export/{id}';

  /**
   * Haal de keys van de geëxporteerde velden op van een specifieke export op basis van het export ID.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getExportDetails()` instead.
   *
   * This method doesn't expect any request body.
   */
  getExportDetails$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<AVGExportDetails>> {

    const rb = new RequestBuilder(this.rootUrl, AVGApiService.GetExportDetailsPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AVGExportDetails>;
      })
    );
  }

  /**
   * Haal de keys van de geëxporteerde velden op van een specifieke export op basis van het export ID.
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getExportDetails$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getExportDetails(params: {
    id: number;
  }): Observable<AVGExportDetails> {

    return this.getExportDetails$Response(params).pipe(
      map((r: StrictHttpResponse<AVGExportDetails>) => r.body as AVGExportDetails)
    );
  }

  /**
   * Path part for operation getExportMedewerkers
   */
  static readonly GetExportMedewerkersPath = '/connect/avgdashboard/export/medewerker';

  /**
   * Haal een lijst van medewerkers die een export hebben gedraaid op voor het gegeven datumbereik (zie queryparameters)
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getExportMedewerkers()` instead.
   *
   * This method doesn't expect any request body.
   */
  getExportMedewerkers$Response(params: {
    begindatum: string;
    einddatum: string;
  }): Observable<StrictHttpResponse<Array<AVGExportMederker>>> {

    const rb = new RequestBuilder(this.rootUrl, AVGApiService.GetExportMedewerkersPath, 'get');
    if (params) {
      rb.query('begindatum', params.begindatum, {});
      rb.query('einddatum', params.einddatum, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<AVGExportMederker>>;
      })
    );
  }

  /**
   * Haal een lijst van medewerkers die een export hebben gedraaid op voor het gegeven datumbereik (zie queryparameters)
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getExportMedewerkers$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getExportMedewerkers(params: {
    begindatum: string;
    einddatum: string;
  }): Observable<Array<AVGExportMederker>> {

    return this.getExportMedewerkers$Response(params).pipe(
      map((r: StrictHttpResponse<Array<AVGExportMederker>>) => r.body as Array<AVGExportMederker>)
    );
  }

}
